import $ from 'jquery';

const setPageNavigation = (MYAPP) => {
  if ($('.pageNavi_item').length < 1) { return; }
  const $item    = $('.pageNavi_item'),
        $wrap    = $item.parent(),
        $current = $item.filter('.is-current');
  let $trg;
  $trg = $current.find('a').addClass('pageNaviTrg js-accordion');
  if (MYAPP.isMobile) {
    $wrap.before($trg);
    $current.hide();
    $trg.off().on('click', function(event){
      event.preventDefault();
      $(this).toggleClass('is-active').
      next().stop(true,true).slideToggle();
    });
  } else {
    if ($current.find('a').length < 1) {
      $trg = $wrap.prev().removeClass('pageNaviTrg js-accordion is-active');
      $current.show().append($trg);
      $wrap.attr('style','');
    }
  }
};

class accordionNav {
  constructor (opt) {
    this.trg = opt.trg;
    this.item = opt.item;
  }

  set() {
    const $trg = $(this.trg);
    const item = this.item;
    if ($trg.length < 1) { return; }
    $trg.off().on('click', function(event){
      event.preventDefault();
      const $this     = $(this),
            $wrap     = $this.parent(),
            $contents = $wrap.next().find(item),
            i         = $wrap.find('li').index(this),
            activeCls = 'is-active',
            duration  = 300;
      const openContents = () => {
        $this.addClass(activeCls);
        $contents.eq(i).stop(true,true).slideDown(duration);
      };
      const closeContents = () => {
        $contents.eq(i).stop(true,true).slideUp(duration,function(){
          $this.removeClass(activeCls);
        });
      };
      const checkContents = () => {
        if ($contents.is(':visible')) {
          $contents.filter(':visible').stop(true,true).slideUp(duration,function(){
            $this.siblings().removeClass(activeCls);
            openContents();
          });
        } else {
          openContents();
        }
      };
      if ($this.hasClass(activeCls)) {
        closeContents();
      } else {
        checkContents();
      }
    });
  }
}

const setSubNavigation = () => {
  const navigation = new accordionNav({
    trg : '.subNavi_item',
    item : '.subNaviContents_item'
  });
  navigation.set();
};

const setSeminarChoice = () => {
  const navigation = new accordionNav({
    trg : '.seminarChoice_nav_item',
    item : '.seminarChoice_contents_item'
  });
  navigation.set();
};

module.exports = {
  setPageNavigation : setPageNavigation,
  setSubNavigation  : setSubNavigation,
  setSeminarChoice  : setSeminarChoice
};



// WEBPACK FOOTER //
// ./src/js/modules/navigation.js